export default {
  labels: {
    today: "Aujourd'hui",
    pickup_time: 'Heure de retrait',
    on_site_time: 'Heure de service',
    delivery_time: 'Heure de livraison',
  },
};
